import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getFormValues} from "redux-form";
import {validatePassword} from "../../util/password";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/pro-light-svg-icons/faLock";
import Button from "../../components/navigation/Button";
import {delve} from "../../util/util";

function mapStateToProps(state, ownProps) {
    return {
        formValues: getFormValues(ownProps.formIdentifier)(state),
        showPassword: delve(state, "ui.showPassword")
    };
}

function mapDispatchToProps(dispatch) {
    return {
        copyPassword: (e) => {

        }
    };
}

class PasswordHint extends Component {

    constructor(props) {
        super(props);
        this.state = {
            passwordCopied: false
        }
        this.copyPassword = this.copyPassword.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.state.passwordCopied !== nextState.passwordCopied) {
            return true;
        }
        if (!this.props.formValues && !nextProps.formValues) {
            return false;
        }
        if (nextProps.formValues && this.props.formValues && nextProps.formValues.projectPassword !== this.props.formValues.projectPassword) {
            return true;
        }
        if (nextProps.formValues && this.props.formValues && nextProps.formValues.projectPasswordRepeat !== this.props.formValues.projectPasswordRepeat) {
            return true;
        }
        return false;
    }

    copyPassword(e) {
        this.setState({
            passwordCopied: true
        });
        const passwordInput =  document.querySelector('input[name="projectPassword"]');
        passwordInput.setAttribute('type', 'text');
        if (navigator.clipboard) {
            navigator.clipboard.writeText(passwordInput.value)
        } else {
            passwordInput.select();
            try {
                document.execCommand('copy')
            } catch (err) {
                alert("Dein Passwort konnte nicht kopiert werden!");
            }
            if (window.getSelection) {
                if (window.getSelection().empty) {  // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) {  // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) {  // IE?
                document.selection.empty();
            }
        }
        if (!this.props.showPassword) {
            passwordInput.setAttribute('type', 'password');
        }
        passwordInput.blur();
    }

    render() {
        if (!this.props.formValues || !this.props.formValues.projectPassword || !this.props.formValues.projectPasswordRepeat) {
            return null;
        }
        const isValidPassword = Object.keys(validatePassword(this.props.formValues.projectPassword, this.props.formValues.projectPasswordRepeat)).length === 0;
        if (!isValidPassword) {
            return null;
        }
        return (
            <div className={"password-copy-hint"}>
                <div className={"password-copy-hint__icon"}>
                    <FontAwesomeIcon fixedWidth={true} icon={faLock}/>
                </div>
                <div className={"password-copy-hint__content"}>
                    <h4>Passwort gespeichert?</h4>
                    <p>Vergiss nicht dir dein hier gesetztes Passwort zu speichern. Du benötigst es später, um auf dein neu angelegtes Projekt im Kundencenter und das Konfigurations-Backend deiner installierten Software zugreifen zu können. </p>
                    {this.state.passwordCopied ? <Button onMouseEnter={(e) => {this.setState({passwordCopied:false})}} onClick={this.copyPassword} label={"Passwort kopiert"}/> : <Button onClick={this.copyPassword} label={"Passwort kopieren"}/>}
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PasswordHint);



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/PasswordHint.js
 **/